/**
 * Nachfrage nach dem Senden: soll ein im Text genannter Termin geblockt
 * werden? (#19)
 *
 * Marlene: „am besten wäre eine aktive Aufforderung nach ABsenden ob man den
 * Blocker anlegen möchte". Vorher hing das am Gedaechtnis — und ein
 * vorgeschlagener Termin ohne Blocker heisst, dass derselbe Platz kurz darauf
 * noch einmal vergeben wird.
 *
 * Geparst wird auf dem Server (`POST /api/v1/emails/{id}/termin-vorschlaege`)
 * mit demselben Parser, der die Wunschtermine eingehender Mails erkennt. Der
 * eben verschickte Text wird mitgeschickt: er steht zu diesem Zeitpunkt noch
 * nicht in `email_log`, sondern kommt erst mit dem naechsten IMAP-Lauf aus dem
 * Gesendet-Ordner zurueck.
 *
 * Gefragt wird im Portal-Dialog, nicht per `window.confirm` — den kann der
 * Browser abschalten, dann kaeme die Frage nie (19.10.2026, siehe
 * `components/portal/Rueckfrage.tsx`).
 */
import { nachfragen } from "@/components/portal/Rueckfrage"

export type TerminVorschlag = { iso: string; label: string }

/** Gibt den zu blockenden Termin zurueck — oder `null`, wenn keiner im Text
 *  steht oder der Nutzer abwinkt. Wirft nie: eine gescheiterte Nachfrage darf
 *  einen erfolgreichen Versand nicht wie einen Fehler aussehen lassen. */
export async function terminBlockerFragen(
  emailId: number,
  text: string,
): Promise<string | null> {
  try {
    if (!(text || "").trim()) return null
    const res = await fetch(`/api/v1/emails/${emailId}/termin-vorschlaege`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text }),
    })
    if (!res.ok) return null
    const daten = await res.json()
    const items = (daten?.items || []) as TerminVorschlag[]
    if (items.length === 0) return null
    const erster = items[0]
    const ja = await nachfragen(items.length === 1
      ? {
          titel: "Als Blocker in den Kalender legen?",
          zeilen: [`Im Text steht ein Termin: ${erster.label}.`],
          ja: "Blocker anlegen",
          nein: "Nein",
        }
      : {
          titel: "Buchen-Fenster oeffnen?",
          zeilen: [
            `Im Text stehen ${items.length} Termine, der naechste ist ${erster.label}.`,
            "Die anderen stehen dort zur Auswahl.",
          ],
          ja: "Fenster oeffnen",
          nein: "Nein",
        })
    if (!ja) return null
    return erster.iso
  } catch {
    return null
  }
}
